import { serializeSuperjson } from '@lib/superjson';
import {
  UpdateSnapQuoteBody,
  UpdateSnapQuoteOutput,
  UpdateSnapQuoteParams,
} from '@snap-types/actions/update-snap-quote';
import { QUOTE_BUILDER_SLICE_NAME } from '@ui/constants/quote-builder';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import { injectMutation } from '@ui/store/api-builder/inject-mutation';

const [updateSnapQuote, _] = injectMutation<
  { params: UpdateSnapQuoteParams; body: UpdateSnapQuoteBody },
  UpdateSnapQuoteOutput
>(`${QUOTE_BUILDER_SLICE_NAME}/updateSnapQuote`, ({ params, body }) => ({
  url: buildSnapQuoteUrl(params.siteCode, params.quoteUuid),
  method: 'PUT',
  body: serializeSuperjson(body),
}));

export { updateSnapQuote };
